module.exports = __webpack_public_path__ + "assets/images/MXD.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/MXD.png
// module id = 1421
// module chunks = 1